import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField, 
  Typography} from '@material-ui/core';
import { createTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
  import { format, isBefore, parse } from 'date-fns';
import React from 'react';
import VariantSnackbar from '../../share/VariantSnackbar';
import FormDialogTipoItem from './FormDialogTipoItem';
import TrashIcon from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import FormDialogItemEspecifico from './FormDialogItemEspecifico';
import FormDialogValor from './FormDialogValor';
import FormDialogAdicionarPrestador from './FormDialogAdicionarPrestador';
import FormDialogAlterarPrestador from './FormDialogAlterarPrestador';
import FormDialogFecharVigencias from './FormDialogFecharVigencias';
import TaxaApi from '../../../api/TaxaApi';
import LinearProgressBlockScreen from '../../share/LinearProgressBlockScreen';


const styles = theme => ({
  body: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  invisible: {
    display: 'none',
  },
  selectAtivo: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
    width:  theme.spacing(10),
  },
  selectTipoTaxa: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(5),
    width:  theme.spacing(70),
  },
  formControlDesTaxa: {
    marginTop: theme.spacing(-0.8),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(5),
    width:  theme.spacing(110),
  },
  typographyPaperItensPrincipal: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
    color: theme.palette.text.primary,
    fontSize: 14,    
  },
  typographyPaperItensSecondary: {
    marginLeft: theme.spacing(2),
    color: theme.palette.text.secondary,
    fontSize: 13,    
  },
  paperItens: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    display: 'inline-grid',
    width: '49%',
  },
  divAdicionarTipoDeItem: {
    textAlign: 'center'
  },
  buttonAdicionar: {
    margin: theme.spacing(2),
  },
  fontTable: {
    fontSize: 12
  },
  iconButton: {
    padding: '3px'
  },
  typographyLabelQtdePrestadores: {
    display: 'inLine-block',
    fontSize: 13,
  },   
});
const getMuiTheme = () =>
  createTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: '0px',
        },
      },
    }
  });

class FormDialogTaxa extends React.Component {
  taxaApi = new TaxaApi();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.taxa,
      fetching: false,
      snackOpen: false,
      snackMessage: '',
      sucesso: false,
      isEditavel: this.props.isEditavel,
      modoInclusao: this.props.modoInclusao,
      openDialogTipoItem: false,
      openDialogItemEspecifico: false,
      openDialogValor: false,
      openDialogPrestadores: false,
      openDialogAlterarPrestador: false,
      openDialogFecharVigencias: false,
      indPrestadorAtivo: '',
      dtaInicio: null,
      dtaFim: null,
      indicePrestador: 0,
      tabelasSelecionadas: [],
      tiposItensSelecionados: [],    
      itensEspecificosSelecionados: [],
      valoresSelecionados: [],
      prestadoresVinculados: [],
      adicionouTiposItem: false,
      adicionouItemEspecifico: false,
      adicionouValor: false,
      adicionouPrestador: false,
      isIndice: false
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  componentDidMount = async () => {
    if(!this.props.modoInclusao){
      this.setState({fetching: true});
      let brancoAcoes = '';
      let tiposItemExtract = [];
      let itensEspecificosExtract = [];
      let valoresExtract = [];
      let prestadoresVinculadosExtract = [];

      let taxaPrestador = await this.taxaApi.consultarPrestadoresTaxa(this.state.codItemTaxa);
      this.setState({taxaPrestador: taxaPrestador});

      this.state.taxaItemTabela.map(res => {
        const { codTabela, desTabela, codTipoItem, desTipoItem, codItem, desItem, codItemTabela, codItemTaxa, codItemTaxaItemTabela } = res;  
        if(codItemTabela === 0){
          tiposItemExtract.push(Object.values({ codTabela, desTabela, codTipoItem, desTipoItem, brancoAcoes, codItemTaxa, codItemTaxaItemTabela }));
        } else {
          itensEspecificosExtract.push(Object.values({ codTabela, desTabela, codTipoItem, desTipoItem, codItem, desItem, brancoAcoes, codItemTabela, codItemTaxa, codItemTaxaItemTabela }));
        }
        });      
        
      this.state.taxaValor.map(res => {
        var { codItemTaxa, valUnitarioInicio, valUnitarioFim, valTaxaPercentual, valIndiceCorrecao } = res;  
        const nf = new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        valTaxaPercentual = valTaxaPercentual === '' ? '' : nf.format(valTaxaPercentual);
        valIndiceCorrecao = valIndiceCorrecao === '' ? '' : nf.format(valIndiceCorrecao);
        valUnitarioInicio = nf.format(valUnitarioInicio);
        valUnitarioFim = valUnitarioFim === '' ? '' : nf.format(valUnitarioFim);
        valoresExtract.push(Object.values({valTaxaPercentual, valIndiceCorrecao, valUnitarioInicio, valUnitarioFim, brancoAcoes, codItemTaxa }));
      });
      
      this.state.taxaPrestador.map(res => {
        const { nomPrestador, codItemTaxaPrestador, codPrestador, dtaInicio, dtaFim, codItemTaxa, indAtivo, indPodeExcluir, indAlterou } = res;
        prestadoresVinculadosExtract.push(Object.values({ nomPrestador, codItemTaxaPrestador, codPrestador, dtaInicio, dtaFim, codItemTaxa, indAtivo, brancoAcoes, indPodeExcluir, indAlterou }));
        });      
  
      this.setState({tiposItensSelecionados: tiposItemExtract, itensEspecificosSelecionados: itensEspecificosExtract,
        valoresSelecionados: valoresExtract, prestadoresVinculados: prestadoresVinculadosExtract, fetching: false});
    }
  }

  isSalvarDisabled = () => {
    return (
      (this.state.codTipoTaxa === undefined) ||
      (this.state.indAtiva === undefined) ||
     (this.state.itensEspecificosSelecionados.length === 0 &&
     this.state.tiposItensSelecionados.length === 0) ||
     (this.state.valoresSelecionados.length === 0) ||
     (this.state.prestadoresVinculados.length === 0)
     );
  }

  handleClickSave = async () => {
    let taxaItensTabela = [];
    for (var i = 0; i < this.state.tiposItensSelecionados.length; i++) {
      let taxaItemTabela = {
        codItemTaxa: this.state.tiposItensSelecionados[i][5],
        codItemTaxaItemTabela: this.state.tiposItensSelecionados[i][6],
        codTabela: this.state.tiposItensSelecionados[i][0],
        desTabela: '-',
        codTipoItem: this.state.tiposItensSelecionados[i][2],
        desTipoItem: '-',
        codItemTabela: 0,
        codItem: '-',
        desItem: '-',
        desItemFormatado: '-',
      }
      taxaItensTabela.push(taxaItemTabela);
    }
    for (var i = 0; i < this.state.itensEspecificosSelecionados.length; i++) {
      let taxaItemTabela = {
        codItemTaxa: this.state.itensEspecificosSelecionados[i][8],
        codItemTaxaItemTabela: this.state.itensEspecificosSelecionados[i][9],
        codTabela: this.state.itensEspecificosSelecionados[i][0],
        desTabela: '-',
        codTipoItem: this.state.itensEspecificosSelecionados[i][2],
        desTipoItem: '-',
        codItemTabela: this.state.itensEspecificosSelecionados[i][7],
        codItem: '-',
        desItem: '-',
        desItemFormatado: '-',
      }
      taxaItensTabela.push(taxaItemTabela);
    }
    let taxaValores = [];
    for (var i = 0; i < this.state.valoresSelecionados.length; i++) {
      let taxaValor = {
        codItemTaxa: this.state.valoresSelecionados[i][5],
        valUnitarioInicio: Number(this.state.valoresSelecionados[i][2].replace('.', '').replace(',', '.')),
        valUnitarioFim: this.state.valoresSelecionados[i][3] === '' ? null : Number(this.state.valoresSelecionados[i][3].replace('.', '').replace(',', '.')),
        valTaxaPercentual: this.state.valoresSelecionados[i][0] === '' ? null : Number(this.state.valoresSelecionados[i][0].replace('.', '').replace(',', '.')),
        valIndiceCorrecao: this.state.valoresSelecionados[i][1] === '' ? null : Number(this.state.valoresSelecionados[i][1].replace('.', '').replace(',', '.')),
        desValorFormatado: '-',
      }
      taxaValores.push(taxaValor);
    }
    let taxaPrestadores = [];
    for (var i = 0; i < this.state.prestadoresVinculados.length; i++) {
      let taxaPrestador = {
        codItemTaxa: this.state.prestadoresVinculados[i][5],
        codItemTaxaPrestador: this.state.prestadoresVinculados[i][1],
        codPrestador: this.state.prestadoresVinculados[i][2],
        dtaInicio: parse(this.state.prestadoresVinculados[i][3]),
        dtaFim: this.state.prestadoresVinculados[i][4] === null || this.state.prestadoresVinculados[i][4] === '-' ? null : parse(this.state.prestadoresVinculados[i][4]),
        indAtivo: this.state.prestadoresVinculados[i][6],
        nomPrestador: '-',
        indAlterou: this.state.prestadoresVinculados[i][9],
      }
      taxaPrestadores.push(taxaPrestador);
    }

    let taxa = {
      codItemTaxa: this.state.codItemTaxa === undefined ? 0 : this.state.codItemTaxa,
      indAtiva: this.state.indAtiva,
      codTipoTaxa: this.state.codTipoTaxa,
      desTaxa: this.state.desTaxa === undefined || this.state.desTaxa === '' ? '-' : this.state.desTaxa,
      taxaItemTabela: taxaItensTabela,
      taxaValor: taxaValores,
      taxaPrestador: taxaPrestadores,
    };
    await this.props.handleSave(taxa);
  }
  handleChange = event => {
    this.setState({[event.target.name]: event.target.value});
    if (event.target.name === 'codTipoTaxa') {
      if(event.target.value === 3){
        this.setState({isIndice: true});
      } else {
        this.setState({isIndice: false});
      }
    }
  }
  handleChangeDescricao = event => {
    this.setState({ [event.target.name]: event.target.value.toUpperCase().substring(0, 80) });
  }
  handleClickAdicionarTipoItem = async () => {
    this.setState({openDialogTipoItem: true});
  }
  handleClickAdicionarItemEspecifico = async () => {
    this.setState({openDialogItemEspecifico: true});
  }
  handleClickAdicionarValor = async () => {
    this.setState({openDialogValor: true});
  }
  handleClickAdicionarPrestadores = async () => {
    this.setState({openDialogPrestadores: true});
  }
  handleCloseDialog = async () => {
    this.setState({
      openDialogTipoItem: false, 
      openDialogItemEspecifico: false,
      openDialogValor: false,
      openDialogPrestadores: false,
      openDialogAlterarPrestador: false,
      openDialogFecharVigencias: false,
    });
  }
  handleSaveAdicionarTipoItem = async (tiposItem) => {
    //if(this.state.modoInclusao){
      let tiposItemAux = this.state.tiposItensSelecionados;
      tiposItemAux = tiposItemAux.concat(tiposItem);
      let tiposItemFiltrados = this.removeTiposDuplicados(tiposItemAux);
      this.setState({openDialogTipoItem: false, tiposItensSelecionados: tiposItemFiltrados, adicionouTiposItem: true});
    //} else {
      
    //}
  }   
  handleSaveAdicionarItemEspecifico = async (itensEspecificos) => {
    //if(this.state.modoInclusao){
      let itensEspecificosAux = this.state.itensEspecificosSelecionados;
      itensEspecificosAux = itensEspecificosAux.concat(itensEspecificos);
      let itensEspecificosFiltrados = this.removeItensDuplicados(itensEspecificosAux);
      this.setState({openDialogItemEspecifico: false, itensEspecificosSelecionados: itensEspecificosFiltrados, adicionouItemEspecifico: true});
    //} else {
      
    //}
  }   

  handleSaveAdicionarValor = async (valores) => {
    //if(this.state.modoInclusao){
      var achouRegComValorTabelaFinalBranco = false;
      var maxValorTabelaFinal = 0;
      for (var i = 0; i < this.state.valoresSelecionados.length; i++) {
        if (this.state.valoresSelecionados[i][3] === ''){
          achouRegComValorTabelaFinalBranco = true;
        } else {
          if (Number(this.state.valoresSelecionados[i][3].replace('.', '').replace(',', '.')) > maxValorTabelaFinal) {
            maxValorTabelaFinal = Number(this.state.valoresSelecionados[i][3].replace('.', '').replace(',', '.'));
          }
        }
      }

      if (maxValorTabelaFinal > Number(valores[0][2].replace('.', '').replace(',', '.'))){
        this.setState({openDialogValor: false, snackOpen: true, sucesso: false, 
          snackMessage: 'O valor inicial da taxa ' + valores[0][2] + ' deve ser maior que o valor ' + maxValorTabelaFinal + '.'});
      } else {
        if (!achouRegComValorTabelaFinalBranco){
          let valoresAux = this.state.valoresSelecionados;
          valoresAux = valoresAux.concat(valores);
          this.setState({openDialogValor: false, valoresSelecionados: valoresAux, adicionouValor: true});
        } else {
          this.setState({openDialogValor: false, snackOpen: true, sucesso: false, snackMessage: 'O valor da última taxa deve ser fechado.'});
        }
      }
    //} else {
      
    //}
  }   

  handleSaveAdicionarPrestadores = async (prestadores) => {
    //if(this.state.modoInclusao){
      this.setState({openDialogPrestadores: false, prestadoresVinculados: prestadores, adicionouPrestador: true});
    //} else {
      
    //}
  }     
  handleClickExcluirTipoItem = async (event, tableMeta) => {
    if (this.state.modoInclusao  || this.state.tiposItensSelecionados[tableMeta.rowIndex][6] === 0) {

      let tiposItemAux = this.state.tiposItensSelecionados.slice();
      tiposItemAux.splice(tableMeta.rowIndex, 1);
      this.setState({tiposItensSelecionados: tiposItemAux});
  
    } else {
      let codItemTaxaItemTabela = this.state.tiposItensSelecionados[tableMeta.rowIndex][6];
      await this.taxaApi.excluirTaxaItemTabela(codItemTaxaItemTabela);
      let tiposItemAux = this.state.tiposItensSelecionados.slice();
      tiposItemAux.splice(tableMeta.rowIndex, 1);
      this.setState({tiposItensSelecionados: tiposItemAux, snackOpen: true, sucesso: true, snackMessage: 'Item excluído com sucesso.'}); 
    }
  }    

  handleClickExcluirItemEspecifico = async (event, tableMeta) => {
    if (this.state.modoInclusao || this.state.itensEspecificosSelecionados[tableMeta.rowIndex][9] === 0) {

      let itensEspecificosAux = this.state.itensEspecificosSelecionados.slice();
      itensEspecificosAux.splice(tableMeta.rowIndex, 1);
      this.setState({itensEspecificosSelecionados: itensEspecificosAux});
  
    } else {
      let codItemTaxaItemTabela = this.state.itensEspecificosSelecionados[tableMeta.rowIndex][9];
      await this.taxaApi.excluirTaxaItemTabela(codItemTaxaItemTabela);
      let itensEspecificosAux = this.state.itensEspecificosSelecionados.slice();
      itensEspecificosAux.splice(tableMeta.rowIndex, 1);
      this.setState({itensEspecificosSelecionados: itensEspecificosAux, snackOpen: true, sucesso: true, snackMessage: 'Item excluído com sucesso.'}); 
    }
  }    

  handleClickExcluirValor = async (event, tableMeta) => {
    //if (this.state.modoInclusao) {

      let valoresAux = this.state.valoresSelecionados.slice();
      valoresAux.splice(tableMeta.rowIndex, 1);
      this.setState({valoresSelecionados: valoresAux});
  
    //} else {
      //let codGuia = this.state.guias[tableMeta.rowIndex][0];
      //let result = await this.guiaApi.excluirGuiaRecurso(this.state.codLoteGuia, codGuia);
      //await this.consultarLoteAposAcao(this.state.codLoteGuia);
    //}
  }    

  handleClickExcluirPrestador = async (event, tableMeta) => {
    if (this.state.modoInclusao) {

      let prestadoresAux = this.state.prestadoresVinculados.slice();
      prestadoresAux.splice(tableMeta.rowIndex, 1);
      this.setState({prestadoresVinculados: prestadoresAux});
  
    } else {
      let codItemTaxaPrestador = this.state.prestadoresVinculados[tableMeta.rowIndex][1];
      let indPodeExcluir = this.state.prestadoresVinculados[tableMeta.rowIndex][8];
      console.log('indPodeExcluir => ' + indPodeExcluir);
      if (indPodeExcluir === 'S'){
        await this.taxaApi.excluirTaxaPrestador(codItemTaxaPrestador);
        let prestadoresAux = this.state.prestadoresVinculados.slice();
        prestadoresAux.splice(tableMeta.rowIndex, 1);
        this.setState({prestadoresVinculados: prestadoresAux, snackOpen: true, sucesso: true, snackMessage: 'Prestador excluído com sucesso.'}); 
      } else {
        this.setState({snackOpen: true, sucesso: false, snackMessage: 'Este prestador não pode ser excluído pois já foi vinculado a algum faturamento.'}); 
      }
    }
  }    
  handleClickAlterarPrestador = async (event, tableMeta) => {
    const dtaFimRawValue = this.state.prestadoresVinculados[tableMeta.rowIndex][4];
    console.log(dtaFimRawValue)
    let dtaFimValue = dtaFimRawValue === null || format(new Date(dtaFimRawValue), 'DD/MM/YYYY')  === '31/12/1969' ? 
        '-' 
      : format(new Date(dtaFimRawValue), 'DD/MM/YYYY')

    this.setState({
      openDialogAlterarPrestador: true, 
      indicePrestador: tableMeta.rowIndex,
      indPrestadorAtivo: this.state.prestadoresVinculados[tableMeta.rowIndex][6],
      dtaInicio: this.state.prestadoresVinculados[tableMeta.rowIndex][3],
      dtaFim: dtaFimValue
    });  
  }    
  handleSaveAlterarPrestador = (prestador) => {
    console.log('prestador => ' + prestador.dtaFim);

    let prestadoresAux = this.state.prestadoresVinculados;
    prestadoresAux[this.state.indicePrestador][6] = prestador.indAtivo;
    prestadoresAux[this.state.indicePrestador][4] = prestador.dtaFim === 'Invalid Date' ? '-' : prestador.dtaFim;
    prestadoresAux[this.state.indicePrestador][9] = 'S';
    this.setState({openDialogAlterarPrestador: false, prestadoresVinculados: prestadoresAux});
  }
  handleClickFecharVigencias = async (event, tableMeta) => {
    let dtaInicio = this.state.prestadoresVinculados[0][3];
    this.setState({openDialogFecharVigencias: true, dtaInicio: dtaInicio});  
  }    
  handleSaveFecharVigencias = (prestador) => {
    let prestadoresAux = this.state.prestadoresVinculados;
    for (var i = 0; i < prestadoresAux.length; i++) {
      prestadoresAux[i][4] = prestador.dtaFim;
      prestadoresAux[i][9] = 'S'
    }
    this.setState({openDialogFecharVigencias: false, prestadoresVinculados: prestadoresAux});
  }

  removeTiposDuplicados (tiposItem) {
    let tiposItemFiltrados = [];
    let achou = false;
    for (var i = 0; i < tiposItem.length; i++) {
      achou = false;
      for (var j = 0; j < tiposItemFiltrados.length; j++) {
        if(tiposItem[i][0] === tiposItemFiltrados[j][0] &&
          tiposItem[i][2] === tiposItemFiltrados[j][2]){
            achou = true;
            break;
          }
      }
      if (!achou){
        tiposItemFiltrados.push(tiposItem[i])
      }
    }
    return tiposItemFiltrados;
  }
  removeItensDuplicados (itensEspecificos) {
    let itensEspecificosFiltrados = [];
    let achou = false;
    for (var i = 0; i < itensEspecificos.length; i++) {
      achou = false;
      for (var j = 0; j < itensEspecificosFiltrados.length; j++) {
        if(itensEspecificos[i][0] === itensEspecificosFiltrados[j][0] &&
          itensEspecificos[i][4] === itensEspecificosFiltrados[j][4]){
            achou = true;
            break;
          }
      }
      if (!achou){
        itensEspecificosFiltrados.push(itensEspecificos[i])
      }
    }
    return itensEspecificosFiltrados;
  }  
  render () {
    const options = {
      print: false,
      download: false,
      search: true,
      viewColumns: false,
      filter: false,
      pagination: true,
      selectableRows: 'none',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
    };       
    const optionsPrestadores = {
      customToolbar: () => {
        return (<Typography className={classes.typographyLabelQtdePrestadores}>Qtde. Prestadores: {this.state.prestadoresVinculados.length}</Typography>);
      },
        print: false,
      download: false,
      search: true,
      viewColumns: false,
      filter: false,
      pagination: true,
      selectableRows: 'none',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,

    };       
    const columnsTipoItem = [
      {
        name: 'codTabela',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Tabela',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'codTipoItem',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Tipo de Item',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              <IconButton
                id={'menuButton'}
                className={this.state.isEditavel !== true ? classes.invisible : classes.iconButton}
                size='small'
                title={'Excluir tipo de item da lista'}
                onClick={event => this.handleClickExcluirTipoItem(event, tableMeta)}
              >
                <TrashIcon fontSize='small' />
              </IconButton>
          );
          },
        }
      },    
      {
        name: 'codItemTaxa',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'codItemTaxaItemTabela',
        options: {
          display: 'excluded',
          filter: false,
        }
      },      
    ];
    const columnsItensEspecificos = [
      {
        name: 'codTabela',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Tabela',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'codTipoItem',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Tipo de Item',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Código',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Descrição',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              <IconButton
                id={'menuButton'}
                className={this.state.isEditavel !== true ? classes.invisible : classes.iconButton}
                size='small'
                title={'Excluir tipo de item da lista'}
                onClick={event => this.handleClickExcluirItemEspecifico(event, tableMeta)}
              >
                <TrashIcon fontSize='small' />
              </IconButton>
          );
          },
        }
      },    
      {
        name: 'codItemTabela',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'codItemTaxa',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'codItemTaxaItemTabela',
        options: {
          display: 'excluded',
          filter: false,
        }
      },      
    ];
    const columnsValores = [
      {
        name: 'Valor Taxa',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value === '' ? '-' : value + '%'}</Typography>;
          },
        }
      },
      {
        name: 'Valor Índice',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value === '' ? '-' : value}</Typography>;
          },
        }
      },
      {
        name: 'Valor de Tabela Inicial',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Valor de Tabela Final',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              <IconButton
                id={'menuButton'}
                className={!this.state.modoInclusao ? classes.invisible : classes.iconButton}
                size='small'
                title={'Excluir Faixa de Valor'}
                onClick={event => this.handleClickExcluirValor(event, tableMeta)}
              >
                <TrashIcon fontSize='small' />
              </IconButton>
          );
          },
        }
      },    
      {
        name: 'codItemTaxa',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
    ];
    const columnsPrestadores = [
      {
        name: 'Prestador',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'codItemTaxaPrestador',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'codPrestador',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Data Início',
        options: {
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 13}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography>;
          },
        }
      },      
      {
        name: 'Data Fim',
        options: {
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 13}}>{value === null || format(new Date(value), 'DD/MM/YYYY')  === '31/12/1969' ? '-' : format(new Date(value), 'DD/MM/YYYY')}</Typography>;
          },
        }
      },      
      {
        name: 'codItemTaxa',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Ativo',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },      
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              <div>
              <IconButton
                id={'menuButton'}
                className={this.state.isEditavel !== true ? classes.invisible : classes.iconButton}
                size='small'
                title={'Excluir Prestador'}
                onClick={event => this.handleClickExcluirPrestador(event, tableMeta)}
              >
                <TrashIcon fontSize='small' />
              </IconButton>
              <IconButton
              id={'menuButton'}
              className={this.state.isEditavel !== true ? classes.invisible : classes.iconButton}
              size='small'
              title={'Alterar Prestador'}
              onClick={event => this.handleClickAlterarPrestador(event, tableMeta)}
            >
              <Edit fontSize='small' />
            </IconButton>
            </div>
        );
          },
        }
      },    
      {
        name: 'indPodeExcluir',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'indAlterou',
        options: {
          display: 'excluded',
          filter: false,
        }
      },

    ];

    const { classes, open, handleClose, titulo, tiposTaxa, tiposItem, tabelas } = this.props;
    const { isEditavel } = this.state;
    console.log(this.state.prestadoresVinculados);
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='xl'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          {this.state.fetching ? <LinearProgressBlockScreen />
          : <DialogContent>
            <Paper className={classes.body} elevation={1}>
              <FormControl>
                <InputLabel shrink htmlFor='tipo-simple' className={classes.selectAtivo}>
                  *Ativo
                </InputLabel>
                <Select
                  disabled={!isEditavel}
                  className={classes.selectAtivo}
                  value={this.state.indAtiva}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'indAtiva',
                  }}
                >                  
                  <MenuItem value={'S'}>{'SIM'}</MenuItem>
                  <MenuItem value={'N'}>{'NÃO'}</MenuItem>
                </Select>
              </FormControl>
              <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' 
              className={classes.selectTipoTaxa}
              >
                *Tipo da Taxa
              </InputLabel>
              <Select
                disabled={!isEditavel}
                className={classes.selectTipoTaxa}
                value={this.state.codTipoTaxa}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTipoTaxa',
                }}
              >
                {tiposTaxa.map((tipo, idx) => {
                  return (<MenuItem key={idx} value={tipo.id}>{tipo.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>  
            <FormControl className={classes.formControlDesTaxa}>
                <TextField
                  value={this.state.desTaxa === null ? '' : this.state.desTaxa}
                  margin='dense'
                  disabled={!isEditavel}
                  id='desTaxa'
                  name='desTaxa'
                  label='Descrição'
                  fullWidth
                  onChange={this.handleChangeDescricao}
                  style={{maxlength: '80'}}                  
                  helperText='(max. 80 caracteres)'
                />
              </FormControl>
            </Paper>
            <Paper className={classes.body} elevation={2}>
              <Typography className={classes.typographyPaperItensPrincipal}>
              *Itens aos quais a taxa se aplica
              </Typography>
              <Typography className={classes.typographyPaperItensSecondary}>
                Informe o tipo, se desejar que a taxa se aplique a todos os itens do tipo e da tabela especificados; ou informe códigos dos itens. é possível usar os dois grupos.
              </Typography>
              <Typography className={classes.typographyPaperItensSecondary}>
                Caso o tipo da taxa seja índice de Correção para Medicamento Restrito Hospitalar, será usado o tipo do item na época da vigência para se determinar se a taxa deve ser ou não aplicada. Nos outros casos, será usado o tipo atual.
              </Typography>
              <Paper className={classes.paperItens} elevation={2}>
                <Typography className={classes.typographyPaperItensPrincipal}>
                Tipos de Item
                </Typography>
                <div className={classes.divAdicionarTipoDeItem}>
                  <Button
                    disabled={!isEditavel}
                    color='primary'
                    variant='contained'
                    size='small'
                    title='Clique para adicionar Tipos de Item'
                    className={!isEditavel ? classes.invisible : classes.buttonAdicionar}
                    onClick={this.handleClickAdicionarTipoItem}
                    id={'adicionarTipoDeItem'}>
                    Adicionar Tipo de Item
                  </Button>
                </div>
                {this.state.tiposItensSelecionados.length > 0 &&
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={this.state.tiposItensSelecionados}
                    columns={columnsTipoItem}
                    options={options}
                  />
                </MuiThemeProvider>}
              </Paper>
              <Paper className={classes.paperItens} elevation={2}>
                <Typography className={classes.typographyPaperItensPrincipal}>
                Itens Específicos
                </Typography>
                <div className={classes.divAdicionarTipoDeItem}>
                  <Button
                    disabled={!isEditavel}
                    color='primary'
                    variant='contained'
                    size='small'
                    title='Clique para adicionar Itens Específicos'
                    className={!isEditavel ? classes.invisible : classes.buttonAdicionar}
                    onClick={this.handleClickAdicionarItemEspecifico}
                    id={'adicionarItemEspecifico'}>
                    Adicionar Item Específico
                  </Button>
                </div>
                {this.state.itensEspecificosSelecionados.length > 0 &&
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={this.state.itensEspecificosSelecionados}
                    columns={columnsItensEspecificos}
                    options={options}
                  />
                </MuiThemeProvider>}
              </Paper>
            </Paper>
            <Paper className={classes.body} elevation={2}>
              <Typography className={classes.typographyPaperItensPrincipal}>
              *Valores da taxa por valor de tabela dos itens
              </Typography>
              <div className={classes.divAdicionarTipoDeItem}>
                <Button
                  disabled={!isEditavel || this.state.codTipoTaxa === 0 || this.state.codTipoTaxa === undefined}
                  color='primary'
                  variant='contained'
                  size='small'
                  title='Clique para adicionar Valores'
                  className={!isEditavel ? classes.invisible : classes.buttonAdicionar}
                  onClick={this.handleClickAdicionarValor}
                  id={'adicionarValor'}>
                  Adicionar Valor
                </Button>
              </div>
              {this.state.valoresSelecionados.length > 0 &&
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={this.state.valoresSelecionados}
                    columns={columnsValores}
                    options={options}
                  />
                </MuiThemeProvider>}
            </Paper>
            <Paper className={classes.body} elevation={2}>
              <Typography className={classes.typographyPaperItensPrincipal}>
              *Prestadores aos quais a taxa se aplica
              </Typography>
              <div className={classes.divAdicionarTipoDeItem}>
                <Button
                  disabled={!isEditavel}
                  color='primary'
                  variant='contained'
                  size='small'
                  title='Clique para adicionar Prestador'
                  className={!isEditavel ? classes.invisible : classes.buttonAdicionar}
                  onClick={this.handleClickAdicionarPrestadores}
                  id={'adicionarPrestador'}>
                  Adicionar Prestador
                </Button>
                <Button
                  disabled={!isEditavel || this.state.prestadoresVinculados.length <= 0}
                  color='primary'
                  variant='contained'
                  size='small'
                  title='Clique para Fechar Vigências'
                  className={!isEditavel ? classes.invisible : classes.buttonAdicionar}
                  onClick={this.handleClickFecharVigencias}
                  id={'fecharVigencias'}>
                  Fechar Todas as Vigências
                </Button>
              </div>
              {this.state.prestadoresVinculados.length > 0 &&
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={this.state.prestadoresVinculados}
                    columns={columnsPrestadores}
                    options={optionsPrestadores}
                  />
                </MuiThemeProvider>}
            </Paper>
          </DialogContent>}
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled() || !this.props.isEditavel}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        <VariantSnackbar
          vertical={'bottom'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        {this.state.openDialogTipoItem &&
        <FormDialogTipoItem
          open={this.state.openDialogTipoItem}
          handleClose={this.handleCloseDialog}
          handleSave={this.handleSaveAdicionarTipoItem}
          titulo={'Adicionar Tipo de Item'}
          tiposItem={tiposItem}
          tabelas={tabelas}
          tabelasSelecionadas={this.state.tabelasSelecionadas}
          tiposItensSelecionados={this.state.tiposItensSelecionados}
          />}
        {this.state.openDialogItemEspecifico &&
        <FormDialogItemEspecifico 
        open={this.state.openDialogItemEspecifico}
        handleClose={this.handleCloseDialog}
        handleSave={this.handleSaveAdicionarItemEspecifico}
        titulo={'Adicionar Item Específico'}
        />}
        {this.state.openDialogValor &&
        <FormDialogValor
        open={this.state.openDialogValor}
        handleClose={this.handleCloseDialog}
        handleSave={this.handleSaveAdicionarValor}
        titulo={'Adicionar Valores'}
        isIndice={this.state.isIndice}
        />}
        {this.state.openDialogPrestadores &&
        <FormDialogAdicionarPrestador
        open={this.state.openDialogPrestadores}
        handleClose={this.handleCloseDialog}
        handleSave={this.handleSaveAdicionarPrestadores}
        titulo={'Adicionar Prestadores'}
        prestadoresVinculados={this.state.prestadoresVinculados}
        />}
        {this.state.openDialogAlterarPrestador &&
        <FormDialogAlterarPrestador
        open={this.state.openDialogAlterarPrestador}
        handleClose={this.handleCloseDialog}
        handleSave={this.handleSaveAlterarPrestador}
        titulo={'Alterar Prestador'}
        indAtivo={this.state.indPrestadorAtivo}
        dtaInicio={this.state.dtaInicio}
        dtaFim={this.state.dtaFim}
        />}
        {this.state.openDialogFecharVigencias &&
        <FormDialogFecharVigencias
        open={this.state.openDialogFecharVigencias}
        handleClose={this.handleCloseDialog}
        handleSave={this.handleSaveFecharVigencias}
        titulo={'Fechar Todas as Vigências'}
        dtaInicio={this.state.dtaInicio}
        />}
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogTaxa);
